export default __webpack_public_path__ + "static/banner_video-a690d4769410ed8dadf8ca43464973af.mp4";